import { StaticQuery, graphql } from "gatsby"
import React from "react"
import Image from "gatsby-image"

import Container from "../global/container"
import SectionTitle from "../section-title"
import PrimaryButton from "../button-primary"

import styles from "../button-primary.module.css"

const About = () => {
  function toggleBio() {
    let toggleText = document.querySelector(".bio-toggle")
    document.querySelector(".short-bio").toggleAttribute("hidden")
    document.querySelector(".long-bio").toggleAttribute("hidden")

    toggleText.innerText =
      toggleText.innerText === "Short Bio" ? "Long Bio" : "Short Bio"
  }

  return (
    <StaticQuery
      query={graphql`
        query {
          gallery: file(name: { eq: "sandra-gallery-5" }) {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
          pressphoto: file(
            name: { eq: "sandra-neil-wallace-publicity-photo" }
          ) {
            publicURL
          }
        }
      `}
      render={data => (
        <>
          <section
            id="about"
            style={{ paddingBottom: "5rem" }}
            aria-labelledby="about-header"
          >
            <Container>
              <SectionTitle
                id="about-header"
                titleClass="title--dark"
                title="About"
              />

              <div className="row">
                <div className="column">
                  <div className="long-bio">
                    <p><strong>Sandra Neil Wallace</strong> is an award-winning author, trailblazing journalist, and community leader known for uncovering, preserving, and amplifying the stories of American changemakers hidden in history.</p>
                    <p>The child of immigrants and refugees from Ukraine and Yugoslavia, she is the first generation in her family to attend university. Sandra soon became a journalist, anchoring the network news before shattering the glass ceiling in sports television as the first woman to host an NHL broadcast on national TV and one of the first journalists covering the WNBA.</p>
                    <p>Sandra's books for young readers on trailblazing Americans have received more than 20 starred reviews and several national awards including the Orbis Pictus Award for Outstanding Nonfiction, the Carter G. Woodson Book Award, SCBWI's Golden Kite Honor Award, and ILA's Social Justice Literature Award. Her titles have also been chosen as Outstanding Science Books, and Best Books of the Year by the American Library Association, <em>Kirkus Reviews</em>, <em>Booklist</em>, and the New York and Chicago Public Libraries.</p>
                    <p>A recipient of the Outstanding Women of New Hampshire Award, <em>The Keene Sentinel</em> Extraordinary Women Award, and New Hampshire's Granite State Award for outstanding contributions to the welfare of state, Sandra co-founded <a href="https://www.keene.edu/news/stories/detail/scholarship-recognizes-first-generation-students-honors-family-ancestries/" target="_blank">The Koenig Siddall First Generation Scholarship Fund</a> and <a href="https://dailygoodnh.org/" target="_blank">The Daily Good</a>, supporting thousands of students through literacy programs and free Global Foods Pantries at New Hampshire colleges. She lives in New Hampshire with her husband and frequent collaborator, author Rich Wallace.</p>
                  </div>
                  <div className="short-bio" hidden>
                    <p>Since blazing a trail in sports as the first woman to anchor an NHL broadcast on national TV, <strong>Sandra Neil Wallace</strong> has been writing stories about trailblazing Americans hidden in history. Her true stories for young readers have received more than 20 starred reviews and several national awards including the Orbis Pictus Award for Outstanding NonFiction for <em>Between the Lines: How Ernie Barnes Went from the Football Field to the Art Gallery</em>, illustrated by Bryan Collier, and been chosen as Outstanding Science Books, and Best Books of the Year by the American Library Association, <em>Booklist</em>, and the New York and Chicago Public Libraries. The child of immigrants and refugees from Ukraine and Yugoslavia, Sandra lives in New Hampshire where she continues to break barriers and create change as co-founder of <a href="https://dailygoodnh.org/" target="_blank">The Daily Good</a>, supporting thousands of students through literacy programs and free Global Foods Pantries at New Hampshire colleges.</p>
                  </div>
                  <button
                    className={`bio-toggle ${styles.button} ${styles.button} ${styles.primary}`}
                    onClick={toggleBio}
                  >
                    Short Bio
                  </button>
                </div>

                <div className="column" style={{ textAlign: "center" }}>
                  <img
                    src={data.gallery.childImageSharp.fluid.src}
                    alt="Sandra Wallace Headshot"
                  />

                  {data.pressphoto ? (
                    <aside style={{ marginTop: "2rem", textAlign: "center" }}>
                      <PrimaryButton
                        buttonText="Publicity Photo"
                        buttonLink={data.pressphoto.publicURL}
                        buttonType="primary"
                        target="_blank"
                      />
                    </aside>
                  ) : null}
                </div>
              </div>
            </Container>
          </section>
        </>
      )}
    />
  )
}

export default About
